import * as errorHandlerActions from "./errorHandlerActions";
import axios from "axios";
import {
  CLEAR_USERS_NOTIFICATION,
  DELETE_USERS_NOTIFICATION,
  GET_USERS_NOTIFICATION,
  READ_ALL_NOTIFICATION,
  READ_USERS_NOTIFICATION,
  RESET_USERS_NOTIFICATION,
} from "./types";
import { showToast } from "../_utils/showToast";
import {
  CLEAR_NOTIFICATION_ENDPOINT,
  DELETE_NOTIFICATION_ENDPOINT,
  GET_NOTIFICATIONS_ENDPOINT,
  READ_ALL_NOTIFICATION_ENDPOINT,
  READ_NOTIFICATION_ENDPOINT,
} from "./endpoints";
import { t } from "i18next";
const format = require("string-format");

export const fetchedNotification = (data) => {
  return {
    type: GET_USERS_NOTIFICATION,
    payload: data.results || [],
    loadMore: data.next !== null,
    previous: data.previous,
  };
};

export const fetchUserNotifications =
  (signalToken, props, workspaceId, page = 1, isLoading) =>
  (dispatch) => {
    return axios
      .get(format(GET_NOTIFICATIONS_ENDPOINT, workspaceId, page), {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        dispatch(fetchedNotification(res.data));
        if (isLoading) isLoading(false);
        return res.data;
      })
      .catch((error) => {
        showToast({
          description: t("notification.fetch_error", { ns: "navbar" }),
          title: t("failed", { ns: "common" }),
          status: "error",
        });
        if (isLoading) isLoading(false);
        // dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const deleteUserNotification =
  (signalToken, props, id, isLoading) => (dispatch) => {
    return axios
      .delete(format(DELETE_NOTIFICATION_ENDPOINT, id), {
        cancelToken: signalToken.token,
      })
      .then(() => {
        dispatch({
          type: DELETE_USERS_NOTIFICATION,
          payload: id,
        });
        if (isLoading) isLoading(false);
      })
      .catch((error) => {
        showToast({
          description: t("notification.delete_error", { ns: "navbar" }),
          title: t("failed", { ns: "common" }),
          status: "error",
        });
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const readUserNotification =
  (signalToken, props, id, link) => (dispatch) => {
    return axios
      .post(
        format(READ_NOTIFICATION_ENDPOINT, id),
        {
          ids: [id],
        },
        {
          cancelToken: signalToken.token,
        }
      )
      .then(() => {
        dispatch({
          type: READ_USERS_NOTIFICATION,
          payload: id,
        });
        if (link) props.history.push(link);
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const clearUserNotifications = (signalToken, props) => (dispatch) => {
  return axios
    .post(CLEAR_NOTIFICATION_ENDPOINT, {
      cancelToken: signalToken.token,
    })
    .then(() => {
      dispatch({
        type: CLEAR_USERS_NOTIFICATION,
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

export const readAllUserNotifications = (signalToken, props) => (dispatch) => {
  return axios
    .post(READ_ALL_NOTIFICATION_ENDPOINT, {
      cancelToken: signalToken.token,
    })
    .then(() => {
      dispatch({
        type: READ_ALL_NOTIFICATION,
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

export const resetNotification = () => {
  return {
    type: RESET_USERS_NOTIFICATION,
  };
};
